// inactivity.service.ts
import { Injectable, Inject, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class InactivityService {
  private timeoutId: any;

  constructor(
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
    private ngZone: NgZone
  ) {
    this.initListener();
    this.initInterval();
  }

  private initListener() {
    this.document.addEventListener('mousemove', () => this.resetTimer());
    this.document.addEventListener('mousedown', () => this.resetTimer());
    this.document.addEventListener('keypress', () => this.resetTimer());
    this.document.addEventListener('DOMMouseScroll', () => this.resetTimer());
    this.document.addEventListener('mousewheel', () => this.resetTimer());
    this.document.addEventListener('touchmove', () => this.resetTimer());
    this.document.addEventListener('MSPointerMove', () => this.resetTimer());
  }

  private initInterval() {
    this.ngZone.runOutsideAngular(() => {
      this.timeoutId = setInterval(() => {
        this.ngZone.run(() => this.logout());
      },  60000); // 5 minutos = 300000 ms
    });
  }

  private resetTimer() {
    clearInterval(this.timeoutId);
    this.initInterval();
  }

  private logout() {
    localStorage.removeItem('currentUser');
    this.router.navigate(['/login']);
  }
}
